// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__JlJhV"};